import React, { useState } from 'react';
import { StyledInput } from '../config/Style';
import Button from '@mui/material/Button';
import axios from "axios";
import LoadingHead from "../config/Loading";

function InputArea({ setAnswer }) {
    const [text, setText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    let QuestionData = async () => {
        if (text.trim() === '') return;
        setIsLoading(true);
        try {
            let response = await axios.post('https://chill-be.aiia-gcu.com/convert', {
                question: text
            });
            console.log(response.data);
            setAnswer(response.data.response);
        } catch (error) {
            console.error('Error', error);
            setAnswer("다시 입력해주세요.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <StyledInput>
            <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Chill하게 바꿀 문장을 입력하세요."
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {isLoading && <LoadingHead />}
                <Button
                    onClick={QuestionData}
                    disabled={isLoading}
                    variant="contained"
                    style={{
                        backgroundColor: isLoading ? "#ccc" : "#FF6347",
                        color: "#fff",
                        fontFamily: "BMJUA",
                        textTransform: "none",
                    }}>
                    {isLoading ? "생성 중..." : "Chill 해지기"}
                </Button>
            </div>
        </StyledInput>
    );
}

export default InputArea;
